import { useEffect, useRef, useState } from "react";

function App({ compareId, hideCompare, bannerPlacement, siteId, addressId, dealId, providerId }) {
  const height = useRef(10);
  const [heightState, setHeightState] = useState(height.current);
  const iframeRef = useRef(null);
  const heightReceivedRef = useRef(false);
  const retryTimersRef = useRef([]);

  useEffect(() => {
    function handleMessage(event) {
      if (event.data?.type === "resize-feed") {
        heightReceivedRef.current = true;
        retryTimersRef.current.forEach(clearTimeout);
        retryTimersRef.current = [];
        height.current = event.data?.height;
        setHeightState(event.data?.height);
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  function handleIframeLoad() {
    heightReceivedRef.current = false;
    retryTimersRef.current.forEach(clearTimeout);
    retryTimersRef.current = [];

    const delays = [0, 500, 1500, 3000, 6000, 10000];
    delays.forEach((delay) => {
      const timer = setTimeout(() => {
        if (iframeRef.current && !heightReceivedRef.current) {
          iframeRef.current.contentWindow.postMessage({ type: "request-height" }, "*");
        }
      }, delay);
      retryTimersRef.current.push(timer);
    });
  }

  let url = "https://live.elberegner.dk";

  let params = new URLSearchParams();
  if (compareId) {
    params.set("compare", compareId);
  }
  if (hideCompare) {
    params.set("hideCompare", hideCompare);
  }
  if (bannerPlacement) {
    params.set("banner-placement", bannerPlacement);
  }
  if (siteId) {
    params.set("site-id", siteId);
  }
  if (addressId) {
    params.set("addressId", addressId);
  }
  if (dealId) {
    params.set("dealId", dealId);
  }
  if (providerId) {
    params.set("providerId", providerId);
  }

  url += `?${params.toString()}`;

  return (
    <iframe
      ref={iframeRef}
      title="Elberegner"
      style={{ width: "100%", height: heightState, border: "none" }}
      src={url}
      onLoad={handleIframeLoad}
    ></iframe>
  );
}

export default App;
